import { render, staticRenderFns } from "./edit-review.vue?vue&type=template&id=8809b822&"
import script from "./edit-review.vue?vue&type=script&lang=ts&"
export * from "./edit-review.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports